export const toastLoading = "Loading..."
export const resolveTime = 1000
export const nameRegex = /\.([^.]+)$/
export const startLimit = 0
export const concatString = "..."
export const defaultLimit = 20
export const toReplaceText = / /g
export const toReplacedText = /_/g
export const chartAt = 0
export const sliceAt = 1
export const limit = 30
export const enquiry_source = ["Agent", "Employee"];
export const vehicle_category = ["Machinary", "Tool"];
export const validation_message = 'The Field is required.';

export const sweetAlertOption = {
    title: "Are you sure?",
    text: "Do You want to Delete!",
    type: "danger",
    showCancelButton: true,
    confirmButtonColor: "#F3C619",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes",
}